import '../newRelic';
import '../styles.css';
if (/^\/recording-layout\/?$/.test(document.location.pathname)) {
    import(
    /* webpackChunkName: "livekit-egress-template" */
    '@marvelapp/livekit-egress-template');
}
else {
    import('./app');
}
